import { IClientComponentDefinition } from '@glidecms/deliver-core-dev/gd-module'

export const WArticleListingFeaturedArticlesCCD: IClientComponentDefinition = {
  name: 'WArticleListingFeaturedArticles',
  load: () =>
    import(/* webpackChunkName: 'WArticleListingFeaturedArticles' */ './client-featured-articles'),
}
